import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Constants, Globals, Socket, SocketEvents } from 'utils';
import { RootState } from 'reducers';
import { ArrowLeft } from 'assets/icons';
import RoomHeaderActions from './room-header-actions';
import VideoSDKRoom from './video-sdk';
import { Modal } from 'components';

interface Props {
  origin: 'advertisement' | 'teleconsultation'
  consultation: any
  token: string
  onClose: () => void
  onFinish: (item: any) => void
}

const VideoRoom = ({ consultation: appt, token, onClose, onFinish, origin }: Props) => {
  const navigation = useHistory();
  const user = useSelector((state: RootState) => state.user);

  const [link, setLink] = useState('');
  const [roomId, setRoomId] = useState('');
  const [appointment, setAppointment] = useState<any>(null);

  const load = useCallback(() => {
    const roomLink = appt?.video_room_url;
    const room_id = String(appt?.video_room_url).split('/').pop() || '';

    if (link === roomLink) return;
    setLink(roomLink);
    setRoomId(room_id);
    setAppointment(appt);
  }, [link, appt]);

  const onCloseRoom = () => {
    Globals.confirm('¿Realmente desea abandonar la sala?', () => onClose());
  };

  const onFinishAppointment = () => {
    Globals.confirm('¿Realmente desea culminar la consulta?', () => onFinish(appt));
  };

  useEffect(() => {
    // const subscriber1 = Socket.on(SocketEvents.CONSULTATION_REQUEST.STARTED, data => {
    //   if (appointment?.id === data.appointment_id) refresh();
    // });

    const subscriber2 = Socket.on(SocketEvents.CONSULTATION_REQUEST.FINISHED, (data: any) => {
      if (appointment?.id === data.appointment_id) navigation.goBack();
    });

    const subscriber3 = Socket.on(SocketEvents.CONSULTATION_REQUEST.ROOM.HOST_LEFT, (data: any) => {
      if (appointment?.id === data.appointment_id) navigation.goBack();
    });

    if (user?.level_id === Constants.LEVELS.AFFILIATE)
      Globals.showWarning('Invita al cliente desde las opciones');

    return () => {
      if (user?.level_id === Constants.LEVELS.AFFILIATE && roomId) {
        Socket.emit(SocketEvents.CONSULTATION_REQUEST.ROOM.LEAVE, {
          appointment_id: appt?.id,
          user_id: appt.client_id,
          doctor_id: appt.affiliate_id,
          level_id: Constants.LEVELS.AFFILIATE,
          room_id: roomId,
        });
      }

      // subscriber1.removeListener(SocketEvents.CONSULTATION_REQUEST.STARTED);
      subscriber2.removeListener(SocketEvents.CONSULTATION_REQUEST.FINISHED);
      subscriber3.removeListener(SocketEvents.CONSULTATION_REQUEST.ROOM.HOST_LEFT);
    };
  }, [
    navigation,
    user?.level_id,
    appt,
    roomId,
    appointment?.id,
    load,
  ]);

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      visible
      withoutClose
      onClose={onCloseRoom}
      className="video-room-modal"
    >
      <div id="video-room">
        <div className="room-header">
          <button className="close-btn" onClick={onCloseRoom}>
            <img src={ArrowLeft} alt="Volver" />
          </button>

          <RoomHeaderActions
            origin={origin}
            consultation={appointment}
            onFinish={onFinishAppointment}
            onCloseRoom={onCloseRoom}
          />
        </div>

        {!!roomId && (
          <VideoSDKRoom token={token} meeting_id={roomId} onClose={onCloseRoom} />
        )}
      </div>
    </Modal>
  );
};

export default VideoRoom;
